module.exports = "<nb-card>\r\n    <nb-card-header>\r\n      <h3>Redirigiendo...</h3>\r\n    </nb-card-header>\r\n  </nb-card>"